module.exports = __webpack_public_path__ + "static/media/vault_white.a91fef17.png";